/**
 * Hur många artiklar vi säger att vi har. En källa, hela sajten.
 *
 * Ägaren 2026-09-15: "vi lovar konsekvent samma antal på hela sidan så vi inte på olika
 * sidor säger olika antal artiklar utan det är globalt styrt". Innan dess stod det
 * 400 000 på 96 ställen, 470 000 på tio och 500 000 på ett — samma löfte i tre versioner,
 * beroende på vilken sida kunden råkade landa på.
 *
 * VARFÖR ETT KONSTANT TAL OCH INTE EN LIVEFRÅGA. Siffran står i metabeskrivningar,
 * ortssidor och strukturerad data som renderas statiskt. En livefråga per sidvisning
 * hade gjort varje sida beroende av databasen för en siffra som ändras några promille
 * i veckan, och den gamla hooken löste det bara i webbläsaren — texten Google och Bing
 * läste visade alltid reservvärdet.
 *
 * Talet uppdateras i stället av `scripts/uppdatera-artikelantal.mjs`, som läser
 * verkligheten och skriver om raden nedan. Det är ALLTID nedrundat till jämna tiotusen,
 * så vi aldrig lovar mer än vi har.
 *
 * Räknas som säljbar: aktiv och prissatt. Inte samma sak som antalet i sitemapen, som
 * dessutom kräver bild och att sidan får indexeras.
 */

/** Uppdaterad 2026-09-15 · verkligt antal 407 141 · nedrundat till jämna tiotusen. */
export const ANTAL_ARTIKLAR = 400000;

/** Formaterat för löptext: "400 000". */
export const ANTAL_TEXT = ANTAL_ARTIKLAR.toLocaleString('sv-SE').replace(/ /g, ' ');

/** Formaterat med plustecken: "400 000+". Används när vi säger "över". */
export const ANTAL_TEXT_PLUS = `${ANTAL_TEXT}+`;
